import _ from "lodash";

export function parseNumber(number: string | number, divideBy?: number): number | null {
    if (_.isString(number) && number.trim().startsWith("< 0")) {
        // This `"< 0"` logic comes from massSpecParser and I no longer recall what it's for.
        return 0;
    }
    // parseFloat can take a string or a number, despite its alleged type definition
    const res = parseFloat(number as string);
    if (isNaN(res)) {
        return null;
    }

    if (divideBy !== undefined && divideBy > 0) {
        return res / divideBy;
    } else {
        return res;
    }
}
